import ModifPositioningDeviceFittingsTypeModal from './modif-positioning-device-fittings-type-modal.vue'
export default ModifPositioningDeviceFittingsTypeModal
